import { useCallback, useEffect, useState } from 'react'

import { Drawer } from 'antd'
import { debounce } from 'lodash'
import { useSelector } from 'react-redux'
import { faClinicMedical } from '@fortawesome/pro-solid-svg-icons'

import { selectUser } from '../../../reducers/UserReducer'
import { Metadata, retrieveMetadata } from '../../../utils/http'
import { TableParameters } from '../../../utils/entities/tableParameters'
import { getSchoolSpecialities } from '../../../utils/api/school'
import SpecialitiesTable from '../InstitutionsView/SpecialitiesTable'
import { ColorsPalette } from '../../../config/colors'
import { OrderBy } from '../../../utils/constants'
import { selectTranslate } from '../../../reducers/LocaleReducer/LocalReducer'
import IconTooltip from '../../../Components/antd/Icons/IconTooltip'
import { isObject } from '../../../utils'

const DEFAULT_DATA = { data: [], meta: new Metadata({ pageSize: 50 }) }

const SchoolSpecialitiesDrawer = ({ school, width = 600, onClose, onTriggerAction }) => {
  const t = useSelector(selectTranslate)
  const user = useSelector(selectUser)

  const [specialities, setSpecialities] = useState(DEFAULT_DATA)
  const [tableParameters, setTableParameters] = useState(new TableParameters({ orderBy: OrderBy.NAME, pageSize: 50 }))
  const [loading, setLoading] = useState(true)

  const fetchSpecialities = useCallback((school) => {
    setLoading(true)

    getSchoolSpecialities(user, school, { ...tableParameters, paginate: true, excludeRoot: true }).then(({ data, meta }) => {
      setSpecialities({ data, meta: retrieveMetadata(meta) })
    }).catch(() => {
      setSpecialities(DEFAULT_DATA)
    }).finally(() => setLoading(false))
  }, [user.id, tableParameters])

  useEffect(() => {
    let fetch = { cancel: () => {} }

    if (isObject(school)) {
      fetch = debounce(() => fetchSpecialities(school), 300)

      fetch()
    }

    return () => {
      fetch.cancel()
    }
  }, [school?.id, fetchSpecialities])

  return (
    <Drawer
      title={<div><IconTooltip icon={faClinicMedical} iconColor={ColorsPalette.SECOND} title={school?.name ?? ''} /> {t('school_specialities_drawer.title')}</div>}
      visible={!!school}
      width={width}
      onClose={() => {
        setSpecialities(DEFAULT_DATA)

        if (typeof onClose === 'function') {
          onClose()
        }
      }}

    >
      <SpecialitiesTable
        data={specialities.data}
        loading={loading}
        metadata={specialities.meta}
        parameters={tableParameters}
        onParametersChange={parameters => setTableParameters(prev => ({ ...prev, ...parameters, page: parameters.search !== prev.search ? 1 : parameters.page }))}
      />
    </Drawer>
  )
}

export default SchoolSpecialitiesDrawer
